import * as React from "react";
const SVGComponent = ({ color = "#636F7C", ...props }) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 4.39062H5C3.89543 4.39062 3 5.28606 3 6.39062V20.3906C3 21.4952 3.89543 22.3906 5 22.3906H19C20.1046 22.3906 21 21.4952 21 20.3906V6.39062C21 5.28606 20.1046 4.39062 19 4.39062Z"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2.39062V6.39062"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2.39062V6.39062"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 10.3906H21"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;